import React, { useEffect, useState } from "react";
import { Label, Input, FormFeedback, Col, Row } from "reactstrap";
import Flatpickr from "react-flatpickr";
import { useSelector, useDispatch } from "react-redux";
import {
  getProjects as onGetProjects,
  getUnits as onGetUnits,
} from "../../../slices/thunks";
const UnitsTab = ({ formik }) => {
  const dispatch = useDispatch();
  const { projects } = useSelector((state) => {
    return state.Project;
  });
  const { units } = useSelector((state) => {
    return state.Unit;
  });

  useEffect(() => {
    if (!projects || projects.length === 0) {
      dispatch(onGetProjects());
    }
  }, [projects, dispatch]);

  const getUnits = (block_id) => {
    dispatch(onGetUnits({ block: block_id }));
  };

  const handleExtraToggle = (index) => {
    const updatedUnits = [...formik.values.units];
    const unit = updatedUnits[index];

    unit.showExtras = !unit.showExtras;

    if (!unit.showExtras) {
      unit.extras = "";

      const updatedPayments = [...formik.values.payments];
      const extraPaymentIndex = updatedPayments.findIndex(
        (payment) => payment.type === "EXTRA" && payment.isExtraPayment
      );

      if (extraPaymentIndex !== -1) {
        const extraPayment = updatedPayments[extraPaymentIndex];

        extraPayment.unitAmounts = extraPayment.unitAmounts.filter(
          (unitAmount) => unitAmount.unit_id !== unit.unitId
        );

        if (extraPayment.unitAmounts.length === 0) {
          updatedPayments.splice(extraPaymentIndex, 1);
        }

        formik.setFieldValue("payments", updatedPayments);
      }
    } else {
      unit.extras = "";
    }

    formik.setFieldValue("units", updatedUnits);
  };

  const handleExtrasAmountChange = (index, value) => {
    const rawValue = value.replace(/[^0-9]/g, "");
    const updatedUnits = [...formik.values.units];
    updatedUnits[index].extras = rawValue;

    const unitId = updatedUnits[index].unitId;
    const unit = updatedUnits[index];

    if (rawValue && parseInt(rawValue) > 0) {
      const extraPaymentIndex = formik.values.payments.findIndex(
        (payment) => payment.type === "EXTRA" && payment.isExtraPayment
      );

      if (extraPaymentIndex === -1) {
        const extraUnitAmount = {
          unit_id: unitId,
          unit_nr: unit.unit_nr,
          unit_type: unit.unit_type,
          amount: rawValue,
        };

        const newExtraPayment = {
          type: "EXTRA",
          vat_percentage: 19,
          booking_date: new Date().toISOString().split("T")[0],
          unitAmounts: [extraUnitAmount],
          isExtraPayment: true,
        };

        const updatedPayments = [newExtraPayment, ...formik.values.payments];
        formik.setFieldValue("payments", updatedPayments);
      } else {
        const updatedPayments = [...formik.values.payments];
        const extraPayment = updatedPayments[extraPaymentIndex];

        const unitAmountIndex = extraPayment.unitAmounts.findIndex(
          (unitAmount) => unitAmount.unit_id === unitId
        );

        if (unitAmountIndex === -1) {
          extraPayment.unitAmounts.push({
            unit_id: unitId,
            unit_nr: unit.unit_nr,
            unit_type: unit.unit_type,
            amount: rawValue,
          });
        } else {
          extraPayment.unitAmounts[unitAmountIndex].amount = rawValue;
        }

        formik.setFieldValue("payments", updatedPayments);
      }
    } else {
      const updatedPayments = [...formik.values.payments];
      const extraPaymentIndex = updatedPayments.findIndex(
        (payment) => payment.type === "EXTRA" && payment.isExtraPayment
      );

      if (extraPaymentIndex !== -1) {
        const extraPayment = updatedPayments[extraPaymentIndex];

        extraPayment.unitAmounts = extraPayment.unitAmounts.filter(
          (unitAmount) => unitAmount.unit_id !== unitId
        );

        if (extraPayment.unitAmounts.length === 0) {
          updatedPayments.splice(extraPaymentIndex, 1);
        }

        formik.setFieldValue("payments", updatedPayments);
      }
    }

    formik.setFieldValue("units", updatedUnits);
  };

  const resetPaymentsWhenUnitsChange = () => {
    const currentPayments = [...formik.values.payments];

    const extraPayment = currentPayments.find(
      (payment) => payment.type === "EXTRA" && payment.isExtraPayment
    );

    let updatedPayments = [];

    if (extraPayment) {
      updatedPayments.push(extraPayment);
    }

    formik.setFieldValue("payments", updatedPayments);
  };

  return (
    <div style={{ padding: "0px 30px" }}>
      <Row>
      <Col md={4} lg={4} xl={3}>
          <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-primary bg-opacity-10 border-0">
              <h5 className="card-title mb-0 text-primary">
                <i className="ri-filter-3-line me-2"></i> Selection Filters
              </h5>
            </div>
            <div className="card-body">
              <div className="mb-4">
                <label htmlFor="project" className="form-label fw-medium">
                  Project
                </label>
                <select
                  name="project"
                  id="project"
                  className={`form-select form-select-sm ${
                    formik.touched.project && formik.errors.project
                      ? "is-invalid"
                      : ""
                  }`}
                  onChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldValue("phase", "");
                    formik.setFieldValue("block", "");
                    formik.setFieldValue("unit", "");
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.project}
                >
                  <option value="">Choose a project...</option>
                  {projects.map((project) => (
                    <option key={project.id} value={project.id}>
                      {project.name}
                    </option>
                  ))}
                </select>
                {formik.touched.project && formik.errors.project ? (
                  <div className="invalid-feedback">{formik.errors.project}</div>
                ) : null}
              </div>

              <div className="mb-4">
                <label htmlFor="phase" className="form-label fw-medium">
                  Phase
                </label>
                <select
                  name="phase"
                  id="phase"
                  className={`form-select form-select-sm ${
                    formik.touched.phase && formik.errors.phase ? "is-invalid" : ""
                  }`}
                  onChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldValue("block", "");
                    formik.setFieldValue("unit", "");
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.phase}
                  disabled={!formik.values.project}
                >
                  <option value="">Choose a phase...</option>
                  {projects
                    .find((proj) => proj.id.toString() === formik.values.project)
                    ?.phases.map((phase) => (
                      <option key={phase.id} value={phase.id}>
                        {phase.name}
                      </option>
                    ))}
                </select>
                {formik.touched.phase && formik.errors.phase ? (
                  <div className="invalid-feedback">{formik.errors.phase}</div>
                ) : null}
              </div>

              <div className="mb-4">
                <label htmlFor="block" className="form-label fw-medium">
                  Block
                </label>
                <select
                  name="block"
                  id="block"
                  className={`form-select form-select-sm ${
                    formik.touched.block && formik.errors.block ? "is-invalid" : ""
                  }`}
                  onChange={(e) => {
                    const selectedBlockId = e.target.value;
                    formik.handleChange(e);
                    getUnits(selectedBlockId);
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.block}
                  disabled={!formik.values.phase}
                >
                  <option value="">Choose a block...</option>
                  {projects
                    .find((proj) => proj.id.toString() === formik.values.project)
                    ?.phases.find(
                      (phase) => phase.id.toString() === formik.values.phase
                    )
                    ?.blocks.map((block) => (
                      <option key={block.id} value={block.id}>
                        {block.name}
                      </option>
                    ))}
                </select>
                {formik.touched.block && formik.errors.block ? (
                  <div className="invalid-feedback">{formik.errors.block}</div>
                ) : null}
              </div>

              <div className="mb-4">
                <label htmlFor="unitType" className="form-label fw-medium">
                  Unit Type
                </label>
                <select
                  name="unitType"
                  id="unitType"
                  className={`form-select form-select-sm ${
                    formik.touched.unitType && formik.errors.unitType
                      ? "is-invalid"
                      : ""
                  }`}
                  onChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldValue("aptType", "");
                    formik.setFieldValue("unit", "");
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.unitType}
                  disabled={!formik.values.block}
                >
                  <option value="">Choose a unit type...</option>
                  {Array.from(new Set(units.map((unit) => unit.unit_type))).map(
                    (unitType) => (
                      <option key={unitType} value={unitType}>
                        {unitType}
                      </option>
                    )
                  )}
                </select>
                {formik.touched.unitType && formik.errors.unitType ? (
                  <div className="invalid-feedback">{formik.errors.unitType}</div>
                ) : null}
              </div>

              {formik.values.unitType === "APT" && (
                <div className="mb-4">
                  <label htmlFor="aptType" className="form-label fw-medium">
                    Apartment Type
                  </label>
                  <select
                    name="aptType"
                    id="aptType"
                    className={`form-select form-select-sm ${
                      formik.touched.aptType && formik.errors.aptType
                        ? "is-invalid"
                        : ""
                    }`}
                    onChange={(e) => {
                      formik.handleChange(e);
                      formik.setFieldValue("unit", "");
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.aptType}
                  >
                    <option value="">Choose an apt type...</option>
                    {units
                      .filter(
                        (unit) =>
                          unit.unit_type === formik.values.unitType &&
                          unit.settlement_price === null
                      )
                      .map((unit) => unit.apt_type)
                      .filter((value, index, self) => self.indexOf(value) === index)
                      .sort((a, b) => a.localeCompare(b))
                      .map((aptType) => (
                        <option key={aptType} value={aptType}>
                          {aptType}
                        </option>
                      ))}
                  </select>
                  {formik.touched.aptType && formik.errors.aptType ? (
                    <div className="invalid-feedback">{formik.errors.aptType}</div>
                  ) : null}
                </div>
              )}

              <div className="mb-3">
                <label htmlFor="unit" className="form-label fw-medium">
                  Available Units
                </label>
                <select
                  name="unit"
                  id="unit"
                  className="form-select form-select-sm"
                  multiple
                  size="8"
                  style={{ height: "auto" }}
                  onChange={(e) => {
                    const selectedOptions = Array.from(
                      e.target.selectedOptions,
                      (option) => option.value
                    );

                    const existingUnits = formik.values.units || [];
                    const newUnits = selectedOptions
                      .filter(
                        (unitId) =>
                          !existingUnits.some((unit) => unit.unitId === unitId)
                      )
                      .map((unitId) => {
                        const unit = units.find((u) => u.id.toString() === unitId);
                        return {
                          unitId,
                          unit_project:
                            projects.find(
                              (project) =>
                                String(formik.values.project) === String(project.id)
                            )?.name || "",
                          unit_phase:
                            projects
                              .find(
                                (project) =>
                                  String(formik.values.project) ===
                                  String(project.id)
                              )
                              ?.phases.find(
                                (phase) =>
                                  String(formik.values.phase) === String(phase.id)
                              )?.name || "",
                          unit_block:
                            projects
                              .find(
                                (project) =>
                                  String(formik.values.project) ===
                                  String(project.id)
                              )
                              ?.phases.find(
                                (phase) =>
                                  String(formik.values.phase) === String(phase.id)
                              )
                              ?.blocks.find(
                                (block) =>
                                  String(formik.values.block) === String(block.id)
                              )?.name || "",
                          unit_nr:
                            units.find((unit) => String(unitId) === String(unit.id))
                              ?.nr || "",
                          unit_floor: unit ? unit.floor : 0,
                          unit_sqm: unit ? unit.net_sqm : 0,
                          unit_type: unit ? unit.unit_type : "",
                          settled_price: unit ? unit.initial_price : 0,
                          extras: 0,
                        };
                      });

                    const updatedUnits = [...existingUnits, ...newUnits];
                    formik.setFieldValue("units", updatedUnits);
                    resetPaymentsWhenUnitsChange();
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.units.map((unit) => unit.unitId)}
                  disabled={!formik.values.unitType}
                >
                  {units
                    .filter(
                      (unit) =>
                        unit.unit_type === formik.values.unitType &&
                        (formik.values.unitType !== "APT" ||
                          unit.apt_type === formik.values.aptType) &&
                        unit.settlement_price === null
                    )
                    .map((unit) => (
                      <option key={unit.id} value={unit.id}>
                        Nr: {unit.nr} | Floor: {unit.floor} | {unit.net_sqm} m²
                      </option>
                    ))}
                </select>
                <div className="form-text small text-muted mt-2">
                  <i className="ri-information-line me-1"></i>
                  Select multiple units by holding Ctrl/Cmd key
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col>
          <div className="container-fluid mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="m-0 fw-bold">Selected Units</h5>
              <div className="d-flex align-items-center">
                <span className="badge rounded-pill bg-primary me-2">
                  {formik.values.units.length}
                </span>
                <span className="text-secondary">Units Selected</span>
              </div>
            </div>

            {formik.values.units.length === 0 ? (
              <div className="text-center p-5 rounded bg-light border border-dashed">
                <div className="mb-3">
                  <i className="bi bi-building fs-1 text-secondary opacity-50"></i>
                </div>
                <h6 className="text-secondary">No Units Selected</h6>
                <p className="text-muted small">
                  Please select units to continue with the reservation process.
                </p>
              </div>
            ) : (
              <div className="position-relative">
                <div
                  className="units-scroll-container position-relative"
                  style={{
                    maxHeight: "450px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    paddingRight: "5px",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                  }}
                  id="units-container"
                >
                  <div className="row row-cols-1 row-cols-lg-2 g-4 p-2">
                    {formik.values.units.map((unit, index) => (
                      <div className="col" key={unit.unitId}>
                        <div className="card shadow-sm">
                          {unit.is_unit_sold ? (
                            <div className="card-header bg-danger text-white d-flex justify-content-center align-items-center py-2">
                              <h6 className="m-0 text-uppercase fw-bold ls-1">
                                Sold
                              </h6>
                            </div>
                          ) : null}

                          <div className="card-header bg-light d-flex justify-content-between align-items-center">
                            <h6 className="m-0">
                              <span className="badge bg-secondary me-2">
                                #{unit.unit_nr}
                              </span>
                              {unit.unit_type}
                            </h6>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => {
                                const filteredUnits =
                                  formik.values.units.filter(
                                    (_, i) => i !== index
                                  );
                                formik.setFieldValue("units", filteredUnits);
                                resetPaymentsWhenUnitsChange();
                              }}
                            >
                              <i className="ri-delete-bin-5-fill fs-16"></i>
                            </button>
                          </div>

                          <div className="card-body p-3">
                            <div className="mb-3">
                              <div className="row g-2 text-center">
                                <div className="col-4">
                                  <div className="p-2 bg-light rounded">
                                    <div className="small text-muted">
                                      Floor
                                    </div>
                                    <div className="fw-bold">
                                      {unit.unit_floor}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div className="p-2 bg-light rounded">
                                    <div className="small text-muted">SQM</div>
                                    <div className="fw-bold">
                                      {unit.unit_sqm}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div className="p-2 bg-light rounded">
                                    <div className="small text-muted">
                                      Block
                                    </div>
                                    <div className="fw-bold">
                                      {unit.unit_block}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2 small text-muted text-center">
                                Project:{" "}
                                <span className="fw-semibold">
                                  {unit.unit_project}
                                </span>{" "}
                                • Phase:{" "}
                                <span className="fw-semibold">
                                  {unit.unit_phase}
                                </span>
                              </div>
                            </div>

                            <hr className="my-3" />

                            <div className="mb-3">
                              <label
                                htmlFor={`settled-price-${index}`}
                                className="form-label small fw-semibold"
                              >
                                Settled Price
                              </label>
                              <div className="input-group mb-3">
                                <span className="input-group-text">€</span>
                                <input
                                  id={`settled-price-${index}`}
                                  type="text"
                                  className="form-control"
                                  placeholder="0.00"
                                  value={
                                    unit.settled_price !== ""
                                      ? Intl.NumberFormat("en-US").format(
                                          unit.settled_price
                                        )
                                      : ""
                                  }
                                  onChange={(e) => {
                                    const rawValue = e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    );
                                    const updatedUnits = [
                                      ...formik.values.units,
                                    ];
                                    updatedUnits[index].settled_price =
                                      rawValue;
                                    formik.setFieldValue("units", updatedUnits);
                                  }}
                                />
                              </div>

                              <div className="form-check form-switch d-flex justify-content-between align-items-center p-0">
                                <label
                                  className="form-check-label"
                                  htmlFor={`extra-finish-${index}`}
                                >
                                  <span className="fw-semibold small">
                                    Extra Finish
                                  </span>
                                </label>
                                <div>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`extra-finish-${index}`}
                                    checked={unit.showExtras || false}
                                    onChange={() => handleExtraToggle(index)}
                                  />
                                </div>
                              </div>

                              <div
                                className="collapse-transition"
                                style={{
                                  maxHeight: unit.showExtras ? "60px" : "0",
                                  opacity: unit.showExtras ? 1 : 0,
                                  overflow: "hidden",
                                  transition:
                                    "max-height 0.3s ease-in-out, opacity 0.2s ease-in-out",
                                  marginTop: unit.showExtras ? "10px" : "0",
                                }}
                              >
                                <div className="input-group">
                                  <span className="input-group-text">€</span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="0"
                                    value={
                                      unit.extras &&
                                      unit.extras !== "" &&
                                      !isNaN(unit.extras)
                                        ? Intl.NumberFormat("en-US").format(
                                            unit.extras
                                          )
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleExtrasAmountChange(
                                        index,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="card-footer bg-white">
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="text-muted small">
                                Total Price:
                              </span>
                              <span className="fw-bold text-primary">
                                €
                                {Intl.NumberFormat("en-US").format(
                                  (parseInt(unit.settled_price) || 0) +
                                    (parseInt(unit.extras) || 0)
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div style={{margin: "10px 0"}}>
              {formik.errors.units ? (
                <div
                  className="alert alert-danger d-flex align-items-center"
                  role="alert"
                >
                  <i className="ri-error-warning-fill me-2 fs-16"></i>
                  <div className="flex-grow-1">
                    <strong>Error: </strong>
                    {typeof formik.errors.units === "string" ? (
                      formik.errors.units
                    ) : Array.isArray(formik.errors.units) ? (
                      <ul className="mb-0 ps-3">
                        {formik.errors.units.map((unitError, index) => {
                          if (!unitError) return null;
                          const unitNr =
                            formik.values.units[index]?.unit_nr ||
                            `#${index + 1}`;

                          return Object.keys(unitError).map((key) => (
                            <li key={`${index}-${key}`}>
                              Unit #{unitNr}:{" "}
                              {key === "settled_price"
                                ? "Price"
                                : key === "is_unit_sold"
                                ? "Status"
                                : key}{" "}
                              - {unitError[key]}
                            </li>
                          ));
                        })}
                      </ul>
                    ) : typeof formik.errors.units === "object" ? (
                      <ul className="mb-0 ps-3">
                        {Object.entries(formik.errors.units).map(
                          ([key, value]) => (
                            <li key={key}>
                              {key}: {value}
                            </li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UnitsTab;
